import React from 'react'
import LoyaltyTierPill from 'components/Luxkit/LoyaltyTierPill'
import TextLink from 'components/Luxkit/TextLink'
import Group from 'components/utils/Group'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'

function TriplePointTakeoverHeroSubtitle() {
  const [tier] = useCurrentLoyaltyTier()

  return <Group direction="horizontal" gap={4}>
    Look for <LoyaltyTierPill variant="primary" tier={tier}>Triple Points</LoyaltyTierPill>{' '}
    on select packages! Valid until 12 July 2025. <TextLink to="/triple-points">View all offers</TextLink>
  </Group>
}

export default TriplePointTakeoverHeroSubtitle
